import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { UpdateFlockPresaleVehiclePage } from "../update-flock-presale-vehicle.page";

@Component({
  selector: "myqq-update-flock-presale-alert",
  templateUrl: "./update-flock-presale-alert.component.html",
  styleUrls: ["./update-flock-presale-alert.component.scss"],
})
export class UpdateFlockPresaleAlertComponent implements OnInit {
  @Output() close = new EventEmitter<boolean>();
  constructor(public dialogRef: MatDialogRef<UpdateFlockPresaleVehiclePage>) {}
  ngOnInit() {
    this.dialogRef.addPanelClass("myqq-alert-dialog");
  }
}
